import { render, staticRenderFns } from "./uploadSentenceGroupPage.vue?vue&type=template&id=25d444b8&"
import script from "./uploadSentenceGroupPage.vue?vue&type=script&lang=js&"
export * from "./uploadSentenceGroupPage.vue?vue&type=script&lang=js&"
import style0 from "./uploadSentenceGroupPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports